import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { FormValues } from '../../MySettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const PulseCheck = ({ formBag, ...rest }: Props) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="PulseCheck" />

      <Toggle {...formBag.register('allowPulseCheckAdviser')}>
        Turn on PulseCheck by default for all clients
      </Toggle>
    </Box>
  );
};
